import { News, Person, PersonNewsItem } from "../types";

export const mapPersonNewsToNews = (
  person: Person,
  items?: Array<News | PersonNewsItem>,
): News[] => {
  if (!items?.length) return [];

  return items.map((n: any): News => {
    const isAlreadyNews =
      "release_date" in n || "subtitle" in n || "projects" in n;

    if (isAlreadyNews) return n as News;

    return {
      id: n.id,
      name: n.name,
      content: "",
      meta_text: null,
      subtitle: n.under_title ?? null,
      tags: [],

      images:
        Array.isArray(n.images) && n.images.length > 0
          ? n.images.map((url: string, index: number) => ({
              id: index,
              url,
              caption: null,
              type: "image",
            }))
          : n.image
            ? [
                {
                  id: 0,
                  url: n.image,
                  caption: null,
                  type: "image",
                },
              ]
            : [],

      projects: (person.projects ?? []).map((p: any) => ({
        id: p.id,
        name: p.name,
        logo: p.logo ?? null,
        categories: p.categories
          ? Array.isArray(p.categories)
            ? p.categories
            : [p.categories]
          : [],
      })),

      categories:
        person.projects?.flatMap((p: any) =>
          p.categories
            ? Array.isArray(p.categories)
              ? p.categories
              : [p.categories]
            : [],
        ) ?? [],

      is_featured: false,
      release_date: n.date_release ?? null,
      created_at: "",
      updated_at: "",
    };
  });
};